import { render, staticRenderFns } from "./RawMaterialHome.vue?vue&type=template&id=12db2b4e&scoped=true"
import script from "./RawMaterialHome.vue?vue&type=script&lang=js"
export * from "./RawMaterialHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db2b4e",
  null
  
)

export default component.exports